import React from 'react';

const SOURCE_LAYER_LABELS = {
  location: 'Orte',
  donation: 'Pfandspenden',
  bottle_message: 'Flaschenpost',
};

const DISTANCE_OPTIONS = [100, 250, 500, 1000];

export function TreasureMapFilterPanel({
  filters,
  categories = [],
  onToggleLayer,
  onSetMaxDistanceMeters,
  onApplyQuickFilter,
  onResetFilters,
}) {
  const safeFilters = filters || {};
  const safeLayers = safeFilters.layers || {};
  const safeCategories = Array.isArray(categories) ? categories : [];

  return (
    <div className="treasure-map-filter-panel">
      <div className="treasure-map-filter-panel__grid">
        <div className="treasure-map-filter-panel__section">
          <h3>Schnellfilter</h3>
          <div className="treasure-map-filter-panel__button-grid">
            <button type="button" onClick={() => onApplyQuickFilter?.('loot-nearby')}>💰 Loot-Runde jetzt</button>
            <button type="button" onClick={() => onApplyQuickFilter?.('donations')}>♻️ Nur Pfandspenden</button>
            <button type="button" onClick={() => onApplyQuickFilter?.('messages')}>🍾 Nur Flaschenpost</button>
            <button type="button" onClick={() => onApplyQuickFilter?.('reset')}>↺ Alles zurücksetzen</button>
          </div>
        </div>

        <div className="treasure-map-filter-panel__section">
          <h3>Maximale Distanz für „in der Nähe“</h3>
          <select
            value={Number(safeFilters.maxDistanceMeters || 100)}
            onChange={(event) => onSetMaxDistanceMeters?.(event.target.value)}
          >
            {DISTANCE_OPTIONS.map((distance) => (
              <option key={distance} value={distance}>
                {distance} m
              </option>
            ))}
          </select>
        </div>

        <div className="treasure-map-filter-panel__section">
          <h3>Ebenen</h3>
          <div className="treasure-map-filter-panel__toggle-list">
            {Object.entries(SOURCE_LAYER_LABELS).map(([key, label]) => (
              <label key={key} className="treasure-map-filter-panel__toggle">
                <input
                  type="checkbox"
                  checked={safeLayers[key] !== false}
                  onChange={() => onToggleLayer?.(key)}
                />
                <span>{label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="treasure-map-filter-panel__section">
          <h3>Kategorien ein- oder ausblenden</h3>
          <div className="treasure-map-filter-panel__toggle-list treasure-map-filter-panel__toggle-list--compact">
            {safeCategories.map((category) => (
              <label key={category.key || category.label} className="treasure-map-filter-panel__toggle">
                <input
                  type="checkbox"
                  checked={safeLayers[category.key] !== false}
                  onChange={() => onToggleLayer?.(category.key)}
                />
                <span>{category.label || category.name}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="treasure-map-filter-panel__footer">
        <button type="button" onClick={onResetFilters}>Filter komplett zurücksetzen</button>
      </div>
    </div>
  );
}

export default TreasureMapFilterPanel;
